import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoadingIndicatorService {

  private progressIndicator = new BehaviorSubject<boolean>(false);
  indicator$ = this.progressIndicator.debounceTime(200);

  /**
   * Stores all currently active requests
   */
  private requests: HttpRequest<any>[] = [];

  constructor() { }

  /**
  * Adds request to the storage and notifies observers
  */
  onStarted(request: HttpRequest<any>) {
    this.requests.push(request);
    this.notify();
  }

  /**
   * Removes request from the storage and notifies observers
   */
  onFinished(request: HttpRequest<any>) {
    const index = this.requests.indexOf(request);
    if (index !== -1) {
      this.requests.splice(index, 1);
    }
    this.notify();
  }

  /**
  * Notifies observers about whether there are any requests on fly
  */
  private notify(): void {
    this.progressIndicator.next(this.requests.length !== 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/loading-indicator.service.ts